import { html } from 'lit';
import { actionLink } from '../components/actionLink.js';
import { highlightedHeading } from '../components/highlightedHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const contactSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    id="kontakt"
    class=${editorNodeClass(editor, 'section.contact', 'vp-contact-section')}
    style=${editorNodeStyle(editor, 'section.contact')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.contact', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.contact', event)}
  >
    <div class="vp-shell vp-contact-layout">
      <div
        class=${editorNodeClass(editor, 'contact.copy')}
        style=${editorNodeStyle(editor, 'contact.copy')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'contact.copy', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'contact.copy', event)}
      >
        ${highlightedHeading({
          title: content.contact.title,
          highlight: content.contact.titleHighlight,
          editor,
          titleElementId: 'contact.title',
          highlightElementId: 'contact.titleHighlight',
        })}
        <p
          class=${editorNodeClass(editor, 'contact.text')}
          style=${editorNodeStyle(editor, 'contact.text')}
          @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'contact.text', event)}
          @click=${(event: MouseEvent) => editorNodeClick(editor, 'contact.text', event)}
        >
          ${content.contact.text}
        </p>
        <div
          class=${editorNodeClass(editor, 'contact.actions', 'vp-hero-actions')}
          style=${editorNodeStyle(editor, 'contact.actions')}
          @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'contact.actions', event)}
          @click=${(event: MouseEvent) => editorNodeClick(editor, 'contact.actions', event)}
        >
          ${actionLink({ action: content.contact.primaryAction, variant: 'light', editor, elementId: 'contact.primaryAction.label' })}
          ${actionLink({ action: content.contact.secondaryAction, variant: 'secondary', editor, elementId: 'contact.secondaryAction.label' })}
        </div>
      </div>

      <address
        class=${editorNodeClass(editor, 'contact.card', 'vp-contact-card')}
        style=${editorNodeStyle(editor, 'contact.card')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'contact.card', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'contact.card', event)}
      >
        <div>
          <span class="icon-[material-symbols--location-on]"></span>
          <p
            class=${editorNodeClass(editor, 'contact.address')}
            style=${editorNodeStyle(editor, 'contact.address')}
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'contact.address', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'contact.address', event)}
          >
            ${content.contact.address}
          </p>
        </div>
        <div>
          <span class="icon-[material-symbols--mail]"></span>
          <p
            class=${editorNodeClass(editor, 'contact.email')}
            style=${editorNodeStyle(editor, 'contact.email')}
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'contact.email', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'contact.email', event)}
          >
            ${content.contact.email}
          </p>
        </div>
        <div>
          <span class="icon-[material-symbols--schedule]"></span>
          <p
            class=${editorNodeClass(editor, 'contact.hours')}
            style=${editorNodeStyle(editor, 'contact.hours')}
            @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'contact.hours', event)}
            @click=${(event: MouseEvent) => editorNodeClick(editor, 'contact.hours', event)}
          >
            ${content.contact.hours}
          </p>
        </div>
      </address>
    </div>
  </section>
`;
